import React from "react";
import { gameCollectionArray } from "../../Globals/globalMetaData";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { gameName } from "../../Redux/gameSettingsSlice";
import { SvgIcon } from "../../Components/SvgIcons";

function GMHome() {
	const navigate = useNavigate();
	const dispatch = useDispatch();

	return (
		<>
			<div className="overviewTableWrapper">
				<div className="overviewTableChild">
					<div className="d-flex flex-wrap">
						<div className="col-12">
							<div className="heading">
								<div className="content">
									<h4>Game Manager</h4>
									<p>Select a game to manage it</p>
								</div>
								<div className="buttonGroup" onClick={() => navigate(-1)}>
									<button className="panelButton gray">
										<span className="text">Back</span>
										<span className="icon">
											<SvgIcon name="back" />
										</span>
									</button>
								</div>
							</div>
						</div>
						<div className="col-12" style={{ padding: "25px 23px" }}>
							<div className="row">
								{gameCollectionArray && gameCollectionArray.length > 0
									? gameCollectionArray.map((item, index) => {
											return (
												<div className="col-auto" key={index}>
													<div
														className="gameWrapper"
														onClick={() => {
															dispatch(gameName(item.value));
															navigate("/set-result", { state: item });
														}}
													>
														<label>{item.label}</label>
														<img src={`/assets/images/games/${item.logo}`} />
													</div>
												</div>
											);
										})
									: ""}
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
}

export default GMHome;
